import Api from "./api.jsx";

import * as Constants from "../../../consts/Constants.js";

import auth from "../../auth/service";

const CULTURE_ROLE = 5012;

class AdsService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdminCulture() {
		return auth.hasRole(CULTURE_ROLE);
	}

}

export default new AdsService(Constants.FINAL_URL_ADS_SERVICE);